import { api, BASE_API_URL } from '@/services/api'
import axios from 'axios'
const API = 'Accounts'

const API_ACCOUNTS = {
  GENERATE_PASSWORD: `${API}/GeneratePassword`,
  LOGIN_WITH_CODE: `${API}/LoginWithCode`,
  LOGOUT: `${API}/Logout`,
  REFRESH_TOKEN: `${API}/RefreshToken`,
  GET_CURRENT_APP_USER: `${API}/GetCurrentAppUser`
}

class ModuleServiceCompanies {
  async generatePassword (data) {
    return api.post(API_ACCOUNTS.GENERATE_PASSWORD, data)
  }
  async loginWithCode (data) {
    return api.post(API_ACCOUNTS.LOGIN_WITH_CODE, data)
  }
  async logout () {
    return api.post(API_ACCOUNTS.LOGOUT)
  }
  async refreshToken (params) {
    return axios.post(`${BASE_API_URL}${API_ACCOUNTS.REFRESH_TOKEN}`, params)
  }
  async getCurrentAppUser () {
    return api.get(API_ACCOUNTS.GET_CURRENT_APP_USER)
  }
}

export const ServiceAccounts = new ModuleServiceCompanies()
